import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { Observable } from 'rxjs';

import { API_PERMISSIONS_URL } from '@appCore/constants/api';
import { Permission } from '@appCore/models/role';
import { environment } from '@appEnvironments/environment';
import { StoreService } from './store.service';

@Injectable({
    providedIn: 'root'
})
export class RolesService {
    constructor(private httpClient: HttpClient, private router: Router, private storeService: StoreService) {}

    public getPermissions(): Observable<Permission[]> {
        return this.httpClient.get<Permission[]>(API_PERMISSIONS_URL);
    }

    public listenRoutes() {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                const pathKey = this.transformUrlToPathKey(event.url);
                const permission = this.findPermissionByPathKey(pathKey);

                if (!environment.isProduction) {
                    //console.log('Not production log --> pathKey', { pathKey, permission });
                }

                this.storeService.setPermission(permission ? permission : ({} as Permission));
            }
        });
    }

    private findPermissionByPathKey(pathKey: string) {
        const permissions = this.storeService.getPermissions();
        return permissions.find((permission) => permission.functionalityName.toLowerCase() === pathKey);
    }

    private transformUrlToPathKey(url: string) {
        const rawUrl = url.split('?')[0];
        const path = rawUrl.startsWith('/') ? rawUrl.slice(1) : rawUrl;
        const parts = path.split('/');
        switch (parts.length) {
            case 0:
                return '';
            case 1:
                return parts[0];
            case 2:
                return parts.join('.');
            default:
                return parts[0] + '.' + parts[parts.length - 1];
        }
    }
}
